module.exports = __webpack_public_path__ + "static/media/p1.617022f8.png";